import WithRender from "../../templates/tables/simpleTable.html";

export default WithRender({
  computed: {},
  props: ["tableName", "useClass"]
});
